//Server node js configuration

/* http://localhost:4000 */
/* https://depoly-work-file.onrender.com */

const production = 'https://bkndadm.designbuildcast.co.uk';
const azureProd = 'https://admin.designbuildcast.co.uk';
const dev = 'http://localhost:4000';
const ContaboURL = 'https://bkndadm.designbuildcast.co.uk';


const frontEnd = 'http://192.168.2.188:3000';
const frontEnd2 = 'https://admin.designbuildcast.co.uk';


module.exports = {

    API_URL: ContaboURL,
    FrondEndURL: frontEnd2

}